var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-btn', {
    staticClass: "text-transform-none white--text",
    attrs: {
      "color": "blue lighten-2",
      "outlined": _vm.copied,
      "rounded": "",
      "icon": _vm.icon,
      "small": _vm.small
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.copyLink();
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": !_vm.icon,
      "small": _vm.small
    },
    domProps: {
      "textContent": _vm._s(_vm.copied ? 'mdi-check' : 'mdi-content-copy')
    }
  }), !_vm.icon ? _c('span', [_vm._v(" " + _vm._s(_vm.copied ? "Copied" : "Copy link") + " ")]) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }